import { render } from "./NewDependencyForm.vue?vue&type=template&id=a7b2d4c0&scoped=true"
import script from "./NewDependencyForm.vue?vue&type=script&lang=js"
export * from "./NewDependencyForm.vue?vue&type=script&lang=js"

import "./NewDependencyForm.vue?vue&type=style&index=0&id=a7b2d4c0&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b2d4c0"]])

export default __exports__